export enum PaginationVariant {
  Purple = 'purple',
  Grey = 'grey',
}

export type PageButtonProps = {
  page: number;
  pages: number;
  maxPages: number;
  onChangePage: (val: number) => any;
  pageVariant: PaginationVariant;
};

export type OverflowPageButtonProps = {
  pageVariant: PaginationVariant;
  overflowText?: string | React.ReactNode;
};
